<app-back-header
  [headerText]="'Torna alla dashboard'"
  (backAction)="backToDashboard()"
  class="sticky-top">
</app-back-header>

  <!-- File input nascosto -->
  <input
    type="file"
    #fileInput
    style="display: none"
    (change)="onFileSelected($event)"
    accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png"
  />

  <!-- Header: titolo + azione primaria della schermata, come la riga
       "titolo + Nuova" delle tabelle bozze/preventivi. -->
  <div class="d-flex justify-content-between align-items-center mt-3 ms-1 mb-3 w-100">
    <h3 class="m-0">Documenti</h3>

    <div class="hidden-mobile">
      <button
        matButton="filled"
        type="button"
        (click)="triggerFileUpload()"
        [disabled]="isUploading"
        matTooltip="Carica un nuovo documento"
        class="flex-shrink-0 izy-button-primary custom-button-border"
      >
        <mat-icon>upload_file</mat-icon>
        {{ isUploading ? 'Caricamento...' : 'Carica documento' }}
      </button>
    </div>
  </div>

  <!-- Mobile: pulsante full-width -->
  <div class="visible-mobile mt-2 w-100 mb-3">
    <button
      matButton="filled"
      type="button"
      (click)="triggerFileUpload()"
      [disabled]="isUploading"
      class="w-100 izy-button-primary custom-button-border"
    >
      <mat-icon>upload_file</mat-icon>
      {{ isUploading ? 'Caricamento...' : 'Carica documento' }}
    </button>
  </div>

  <!-- Loading State -->
  <ng-container *ngIf="isLoading; else contentTemplate">
    <div class="loading-container">
      <mat-progress-spinner diameter="50" mode="indeterminate"></mat-progress-spinner>
      <p class="mt-3">Caricamento in corso...</p>
    </div>
  </ng-container>

  <!-- Content Template -->
  <ng-template #contentTemplate>
    <!-- No Documents State -->
    <ng-container
      *ngIf="documentGroups.length === 0; else documentsTemplate">
      <!-- Stato vuoto con la stessa impaginazione degli altri elenchi
           (icona opaca, titolo, riga di spiegazione). -->
      <div class="empty-container">
        <mat-icon>no_sim</mat-icon>
        <h3>Nessun documento da mostrare qui...</h3>
        <p>Non ci sono documenti caricati per questa organizzazione.</p>
      </div>
    </ng-container>

    <!-- Documents grouped by category -->
    <ng-template #documentsTemplate>
      <!-- Filter chips per category: stessa grammatica delle chip di filtro
           delle altre tabelle (pill con contorno 2px, selezionata in petrol
           pieno). -->
      <div class="mb-2 ms-1" *ngIf="categoryFilterOptions.length > 1">
        <mat-chip-listbox
          aria-label="Filtra per tipologia di documento"
          class="status-chip-set"
          [value]="selectedCategory"
          (change)="applyCategoryFilter($event.value)"
          hideSingleSelectionIndicator
        >
          <mat-chip-option
            *ngFor="let option of categoryFilterOptions; trackBy: trackByFilterValue"
            [value]="option.value"
            [selectable]="true"
            [matTooltip]="'Mostra solo: ' + option.name"
          >
            {{ option.name }}
          </mat-chip-option>
        </mat-chip-listbox>
      </div>

      <!-- Section per category -->
      <ng-container *ngFor="let group of documentGroups; trackBy: trackByCategory">
        <h5 class="ms-2 mt-3 mb-2">{{ group.label }}</h5>

        <div class="documents-list">
          <div *ngFor="let document of group.documents" class="document-item">
            <!-- Card documento: superficie piatta bianca con bordo nero 2px e
                 angolo basso-sinistra vivo, come le card notifica/fattura/
                 cliente (utility globali .custom-card-border / .izy-sharp-bl
                 in styles.scss). Il comando "Visualizza" vive nel footer su
                 fondo panna, separato dal tratto nero 2px. -->
            <mat-card class="document-card izy-sharp-bl custom-card-border">
              <mat-card-content class="document-content">
                <h6 class="document-name d-flex align-items-center flex-wrap">
                  <span class="me-2">{{ document.name }}</span>
                  <span
                    *ngIf="document.is_uploaded_by_user"
                    class="uploaded-badge"
                  >
                    <mat-icon class="badge-icon">person</mat-icon>
                    Caricato da te
                  </span>
                </h6>
                <p class="document-category mb-0">
                  <mat-icon class="document-category-icon me-1">
                    {{ group.icon }}
                  </mat-icon>
                  {{ group.label }}
                </p>
              </mat-card-content>

              <div
                *ngIf="document.file"
                class="d-flex justify-content-end align-items-center document-card-footer">
                <!-- Un solo comando per tutte le larghezze: nel footer il
                     testo ci sta anche su mobile, quindi non serve piu' la
                     variante icona-sola (prima erano due pulsanti gemelli
                     alternati da hidden-mobile / visible-mobile). -->
                <button
                  mat-stroked-button
                  (click)="openAttachment(document.file)"
                  matTooltip="Apri il documento."
                  class="me-2 document-attachment-btn custom-button-border"
                >
                  <mat-icon>visibility</mat-icon>
                  Visualizza
                </button>
              </div>
            </mat-card>
          </div>
        </div>
      </ng-container>

      <!-- TODO: Payment Section -->
      <!-- <ng-container>
          <h5 class="ms-2 mt-3 mb-3">Pagamenti</h5>

          <mat-card class="contract-card">
            <mat-card-content>
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <h6 class="mb-1">Pagamento effettuato</h6>
                  <p class="text-muted mb-0 small">
                    <mat-icon class="me-1" style="vertical-align: middle; font-size: 16px;">
                      attach_money
                    </mat-icon>
                    RIcevuta pagamento
                  </p>
                </div>

                <button
                  *ngIf="payment_data?.attached_receipt"
                  mat-stroked-button
                  color="primary"
                  (click)="openAttachment(payment_data?.attached_receipt!)"
                  class="ms-2 hidden-mobile attachment-button"
                >
                  <mat-icon>visibility</mat-icon>
                  Scarica contratto
                </button>
                <button
                  *ngIf="payment_data?.attached_receipt"
                  mat-stroked-button
                  color="primary"
                  (click)="openAttachment(payment_data?.attached_receipt!)"
                  class="m-0 align-items-center text-center visible-mobile attachment-button"
                >
                  <mat-icon class="ms-2">visibility</mat-icon>
                </button>
              </div>
            </mat-card-content>
          </mat-card>
      </ng-container> -->

    </ng-template>
  </ng-template>
